import './AppMonitorsCell.scss';

import { DataSecurityMonitorReference } from '@sonar-software/sonar-core';
import { EditBox } from '@ui/EditBox';
import { getMonitorRoute } from '@lib/routes';
import { monitorMenuConfigs } from '@security/monitors/monitor-form/MonitorMenu';
import { useFeatureFlags } from '@hooks';
import { useNavigate } from 'react-router-dom';

import { EditOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { Else, If, Then } from 'react-if';
import React, { useMemo } from 'react';

export interface AppMonitorsCellProps {
	applicationId: number,
	monitors: DataSecurityMonitorReference[]
}

export const AppMonitorsCell: React.FC<AppMonitorsCellProps> = ({ applicationId, monitors }) => {
	const navigate = useNavigate();
	const { isEnabled } = useFeatureFlags();

	const initialMonitors = useMemo(() => monitors.filter((monitor) => {
		const flag = monitorMenuConfigs
			.find((config) => config.type === monitor.monitorTypeId)?.featureFlag;

		return flag ? isEnabled(flag) : true;
	}), [ isEnabled, monitors ]);

	return (
		<EditBox
			className='app-monitor-cell'
			isSpreadsheet
			onClick={ () => navigate(getMonitorRoute(applicationId)) }>
			<If condition={ initialMonitors.length > 0 }>
				<Then>
					{ initialMonitors.map((monitor) => <div key={ monitor.monitorName }>{ monitor.monitorName }</div>) }
					<div className='edit-icons'>
						<EditOutlined
							className='edit-icon' />
					</div>
				</Then>
				<Else>
					<div className='add-icons'>
						<PlusSquareOutlined />
					</div>
				</Else>
			</If>
		</EditBox>);
};
